import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

export function getContext() {
	const queryClient = new QueryClient({
		defaultOptions: {
			queries: {
				// Fail fast and surface errors to the nearest ApiErrorBoundary instead of
				// retrying. Set globally so individual queries don't each repeat `retry: false`.
				retry: false,
			},
		},
	})
	return {
		queryClient,
	}
}

export function Provider({ children, queryClient }: { children: React.ReactNode; queryClient: QueryClient }) {
	return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
